// extracted by mini-css-extract-plugin
module.exports = {"input_group":"InputGroup_input_group__2oJEZ","input":"InputGroup_input__2asPY","placeholder":"InputGroup_placeholder__J0q9Y","focus":"InputGroup_focus__Ze8X_"};